export const isFunction = (variable) => {
  if (typeof variable !== "function") return false;
  return true;
};
